export default __webpack_public_path__ + "static/media/wind-mill.12de50f1.png";